<div class="full-page">
  <div>
    <mat-tab-group
      #myTab
      (selectedTabChange)="tabChanged()"
      [selectedIndex]="0"
      [class.hidden]="!showChart"
    >
      <mat-tab
        *ngFor="let t of statTabs"
        label="{{ t.name }} {{ statTotal(t) }}"
      >
      </mat-tab>
    </mat-tab-group>

    <div [class.hidden]="!showChart">
      <div style="display: block; width: 350px; height: 188px">
        <canvas
          baseChart
          [data]="pie.data"
          type="pie"
          [options]="pie.options"
          (chartClick)="pie.chartClicked($event)"
        ></canvas>
      </div>
    </div>
    <a
      [class.hidden]="!showChart"
      *ngFor="let s of currentTabStats.moreStats"
      (click)="setCurrentStat(s)"
      >{{ s.name }} - {{ s.value }},
    </a>
    <div *ngIf="showTotalBoxes()" [class.hidden]="!showChart">
      {{ showTotalBoxes() }}
      <a (click)="calcTotalItems()"> {{ settings.lang.calcTotalItems }} </a>
      <div *ngIf="currentTabStats === assignedButNotOutBaskets">
        ⚠️ ב27/6 שינינו לשונית זו לכלול גם את הטרם שוייכו. מעכשיו כלולים טרם
        שוייכו וכאלו ששוייכו ועוד לא נשלח להם SMS
      </div>
    </div>

    <strong>{{ deliveries.totalRows }} {{ settings.lang.deliveries }} </strong>
    <strong *ngIf="currentStatFilter">
      - {{ currentStatFilter.name }} -
    </strong>
    <a *ngIf="currentStatFilter" (click)="clearStat()">{{
      settings.lang.showAll
    }}</a>

    <div style="display: flex; justify-content: space-between">
      <div>
        <mat-form-field>
          <input
            matInput
            [(ngModel)]="searchString"
            (input)="doSearch()"
            placeholder="{{ settings.lang.searchFamily }}"
            [ngModelOptions]="{ standalone: true }"
          />
          <mat-icon matSuffix (click)="clearSearch()">clear</mat-icon>
        </mat-form-field>
        <br />
      </div>
      <div>
        <button
          mat-raised-button
          color="primary"
          (click)="newFamily()"
          *ngIf="canAdd"
        >
          {{ settings.lang.newFamily }}
        </button>
      </div>
    </div>
  </div>
  <data-grid [settings]="deliveries" class="grow-item"></data-grid>
</div>
